export default {
  LIST: {
    TITLE: `Bulletin list`,
    SUMMARY: `Publish messages to choosen employee on the bulletin board, see who saw the messages and send them directly by email and SMS.`
  },
  CREATE_HEADER: {
    TITLE: `Create a bulletin`,
    SUMMARY: `Bulletins can be marked as visible only for a segment of the users by their teams, departments and hiring data. Bulletins will by visible in the web application and the mobile application by default, it will then be possible to send them by email or SMS.`
  },
  EDIT: {
    TITLE: `Edit the bulletin`,
    SUMMARY: `Bulletins can be marked as visible only for a segment of the users by their teams, departments and hiring data. Bulletins will by visible in the web application and the mobile application by default, it will then be possible to send them by email or SMS.`
  },
  VIEW: {
    TITLE: `View the bulletin`,
    SUMMARY: ``
  },
  VIEW_ARCHIVED: `View archived bulletins`,
  HIDE_ARCHIVED: `Hide archived bulletins`,
  ARCHIVED: `Archived`,
  CREATE: `Create a bulletin`,
  SEND_NOTIFICATIONS: `Send notifications`,
  NOTIFICATIONS_STATUS: `Notification status`,
  PUBLISHED_BY: 'Published by {{ name }} on {{ date }}',
  MODIFIED_BY: `Last modified by {{ name }} on {{ date }}`,
  SHOWN_ON: `Shown from {{ start }} to {{ end }}`,
  VISIBLE_FOR: `Shown to`,
  VISIBLE_TO_EVERONE: `Shown to everybody`,
  SHOWN_UNTIL: `Shown until {{ end }}`,
  SHOWN_FROM: `Shown from {{ start }}`,
  UNSENT_SMS_NOTIFICATIONS: `One bulletin has an unsent SMS notification!`,
  UNSENT_SMS_NOTIFICATIONS_other: `{{ count }} bulletins have unsent SMS notifications!`,
  READ_BY: {
    TITLE: `Read by`,
    SUMMARY: ``
  },
  DELETE: `Delete`,
  PIN: `Pin`,
  UNPIN: `Unpin`,
  ARCHIVE: `Archive`,
  UNARCHIVE: `Unarchive`,
  DELETE_MODAL: {
    TITLE: `Delete the bulletin`,
    SUMMARY: `Are you sure you want to delete this bulletin?`,
    PRIMARY_ACTION: `Delete`
  },
  NOTIFICATION_STATUS: {
    TITLE: `Notification status`,
    SUMMARY: ``
  },
  SMS: `Text messages`,
  EMAILS: `Emails`,
  ERRORS: `Errors`,
  PENDING: `Pending`,
  DELIVERED: `Delivered`,
  OPENED: `Opened`,
  SEND_NOTIFICATIONS_MODAL: {
    TITLE: `Send bulletin notification`,
    SUMMARY: `By clicking on send, you will send an email mentioning this bulletin to {{amount}} users.`
  },
  SEND_BY_EMAIL: `Send by email (free)`,
  NO_EMAIL_VERSION: `Sending email bulletins is not possible when there is no content, please edit the bulletin to add content.`,
  SEND_BY_SMS: `Send by sms`,
  NO_SMS_VERSION: `Sending sms bulletin is not possible when there is no sms version, please edit the bulletin to add one.`,
  SMS_CREDIT_COST: `Sending this bulletin might cost up to {{credit}} credit.`,
  BULLETIN_SENT: `Notification sent`,
  BULLETIN_SENT_DESC: `It could take multiple minutes to multiple hours to be delivered to every user depending on the size of the message and the amount of users.`,
  form: {
    TITLE: {
      LABEL: `Title`,
      PLACEHOLDER: `Enter the bulletin title`,
      DESCRIPTION: `The title will be used to send context to the users when sending a push notification.`
    },
    CONTENT: {
      LABEL: `Content`,
      DESCRIPTION: `The content will be visible to the users and sent in the email notification.`
    },
    SMSCONTENT: {
      LABEL: `Sms version of bulletin`,
      PLACEHOLDER: `Write a condensed version of this bulletin to be sent as an sms to users.`,
      DESCRIPTION: `This text will be used to add context to the user when sending an SMS notification.`
    },
    ISIMPORTANT: {
      LABEL: `Mark this bulletin as important`,
      DESCRIPTION: `Will adds an exclamation point next to the title.`
    },
    PINNED: {
      LABEL: `Pin this bulletin`,
      DESCRIPTION: `The bulletin will stay at the top of the bulletin list.`
    },
    HASSTART: {
      LABEL: `This bulletin has a start date`,
      DESCRIPTION: `The bulletin will not be visible for the users before the date.`
    },
    HASEND: {
      LABEL: `This bulletin has an end date`,
      DESCRIPTION: `The bulletin will not be visible for the users after the date.`
    },
    HASFILTER: {
      LABEL: `Restrict this bulletin's visibility`,
      DESCRIPTION: ``
    },
    START: {
      LABEL: `Start date of publication`,
      PLACEHOLDER: `Enter the start date`,
      DESCRIPTION: ``
    },
    RANGE: {
      LABEL: `Duration of publication`,
      PLACEHOLDER: `Enter the duration`,
      DESCRIPTION: ``
    },
    BULLETINFILTER: {
      LABEL: `Visible for`,
      DESCRIPTION: ``
    },

    SMS_CONTENT_COST: `This message will use {{credit}} credit(s) per user it is sent to.`,
    SMS_CONTENT_EXPENSIVE_CARACTERS: `The following characters considerably increase the cost of the message, consider replacing them: <0>{{expensiveCaracters}}</0>.`,
    BULLETIN_OPTIONS: `Other options`,
    EXAMPLE_SMS: `Hi {{ name }}, {{ companyNameEn }} sent you a bulletin. \n\n{{ smsContent }}`,
    EXAMPLE_SMS_CONTENT: `Hi {{ name }}, {{ companyNameEn }} sent you a bulletin. \n\n{{ smsContent }} \n\nLog in to Merinio to view more: URL`,
    SMS_CONTENT_PREVIEW: `SMS preview`
  },
  NO_BULLETINS: `No bulletins to display`,
  END_BEFORE_START: `The end date must be after the start date.`
}
